/**
 * Web application entry point.
 * Initializes Firebase and renders the root React component.
 */
import { StrictMode } from 'react';

import { createRoot } from 'react-dom/client';

import { initializeFirebase } from '@chartai/firebase';

import { App } from '@/app/App';
import { env } from '@/config/env';

import '@/styles/globals.css';

// Hotjar is injected into index.html's <head> at build time (vite.config.ts),
// gated on VITE_HOTJAR_ID — no runtime bootstrap needed here.
initializeFirebase(env.firebase, {
  appCheckSiteKey: env.appCheck.recaptchaSiteKey || undefined,
  appCheckDebug: env.appCheck.debugToken || undefined,
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
